'use client';
import { useTranslation } from '@whoop/i18n/lang/client';
import { useState } from 'react';
import { shareReferralMessage } from '../../utils/RAFHelpers';
import styles from './referAFriend.module.scss';
import { NewReferAFriend } from './NewReferAFriend/NewReferAFriend';

interface IReferAFriendProps {
  placedOrderMessage: string | undefined;
  imageSrc: string;
  trackingMethods: {
    trackSegment: () => void;
    trackReferralInvitationSent: () => void;
    trackRAFInviteFriend: () => void;
  };
}

export function ReferAFriend({
  placedOrderMessage,
  imageSrc,
  trackingMethods,
}: IReferAFriendProps): JSX.Element | null {
  const { t } = useTranslation('receiptPage');
  const { trackSegment, trackReferralInvitationSent, trackRAFInviteFriend } =
    trackingMethods;
  const [linkCopied, setLinkCopied] = useState(false);

  if (!placedOrderMessage) return null;

  const onShareClick = async (): Promise<void> => {
    trackRAFInviteFriend();
    const _linkCopied = await shareReferralMessage({
      shareData: {
        text: placedOrderMessage,
        title: t('whoopReferral'),
      },
      trackReferralInvitationSent,
    });
    setLinkCopied(_linkCopied);
    trackSegment();
  };

  return (
    <div className={styles.rafSection}>
      <NewReferAFriend
        imageSrc={imageSrc}
        linkCopied={linkCopied}
        onShareClick={onShareClick}
      />
    </div>
  );
}
